import {
    FETCH_START,
    FETCH_END,
    GET_EXECUTION_LOG_SUCCESS,
    RUN_GLOBAL_API_LOG_DATA,
    GET_CUSTOM_TABLES,
    GET_CUSTOM_TABLE_BY_ID_SUCCESS,
    ADD_CUSTOM_TABLE_SUCCESS,
    DELETE_CUSTOM_TABLE_SUCCESS,
    DELETE_CUSTOM_TABLE_FAIL,
    ACTIVATE_CUSTOM_TABLE,
    EDIT_CUSTOM_TABLE_SUCCESS,
    EDIT_CUSTOM_TABLE_FAIL,
    GET_EXTEND_TABLE_FIELDS_SUCCESS,
    CUSTOM_TABLE_SEARCH_SUCCESS,
    CUSTOM_DATA_FORMAT_SUCCESS,
    CUSTOM_DATA_UPLOAD_FAILURE,
    CUSTOM_TABLE_FILTER_DATA_SUCCESS,
    CUSTOM_TABLE_UPDATE_SUCCESS,
    LAYOUT_RENDER_SUCCESS,
    ADD_FILTER_CONFIGURATION_SUCCESS,
    GET_FILTER_CONFIGURATIONS,
    GET_FILTER_CONFIGURATIONS_BY_PAGE,
    GET_FILTER_CONFIGURATION_BY_ID_SUCCESS,
    DELETE_FILTER_CONFIGURATION_SUCCESS,
    DELETE_FILTER_CONFIGURATION_FAIL,
    GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import secureLocalStorage from 'react-secure-storage';
import { toast as globalToast } from '../../../components/ToastManager';
import { history } from '../../../components/Helpers';
import { updateFilterConfiguration } from '../MaterialMaster/MaterialMasterAction';
import { toast } from 'react-toastify';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const fetchStart = () => {
    return {
        type: FETCH_START,
    };
};

export const fetchEnd = () => {
    return {
        type: FETCH_END,
    };
};

export const getExecutionLogData = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());

        try {
            const response = await getExecutionLogDataApi(data);

            dispatch(fetchEnd());

            const responseData = response?.data?.response;

            dispatch(getExecutionLogDataSuccess(responseData));

            return responseData;

        } catch (error) {
            dispatch(fetchEnd());
            dispatch(getExecutionLogDataSuccess({}));

            return null;
        }
    };
};
const getExecutionLogDataApi = (data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    result = axios.post('execution-log', data, { headers: headers });
    return result;
};

export const getExecutionLogDataSuccess = (data) => {
    return {
        type: GET_EXECUTION_LOG_SUCCESS,
        data,
    };
};
//Custom Table Actions
export const deleteCustomTable = (id, tableName) => {
    return async (dispatch) => {
        try {
            const response = await deleteCustomTableAPI(id);
            dispatch({
                type: DELETE_CUSTOM_TABLE_SUCCESS,
                payload: response.data,
            });
            const logNumber = response?.data?.log_number;
            if (response?.data?.response) {
                globalToast.showSuccess(response.data.response);
            } else if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }

            if (tableName) {
                try {
                    const filterResp = await getFilterConfigurationsAPI({
                        page_name: 'GC_custom_data',
                        filter_group: tableName,
                    });
                    const filters = filterResp?.data?.response || [];
                    const matched = filters.find((f) => f?.filter_group === tableName);
                    if (matched?.ID) {
                        await deleteFilterConfigurationAPI(matched.ID);
                    }
                } catch (filterErr) {
                    globalToast.showWarning(
                        `Table '${tableName}' deleted, but its filter configuration could not be removed. Please delete it manually from the Global Filter Configuration page.`,
                    );
                }
            }
        } catch (error) {
            dispatch({ type: DELETE_CUSTOM_TABLE_FAIL });
        }
    };
};

const deleteCustomTableAPI = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
    };
    return axios.delete(`mdm/custom-table/${id}`, { headers });
};

export const dropCustomTable = (id) => {
    return async (dispatch) => {
        try {
            const response = await dropCustomTableAPI(id);
            const logNumber = response?.data?.log_number;
            if (response?.data?.response) {
                globalToast.showSuccess(response.data.response);
            } else if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
        } catch (error) {
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showError(
                    error?.response?.data?.message || 'Failed to drop custom table',
                );
            }
        }
    };
};

const dropCustomTableAPI = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
    };
    return axios.delete(`mdm/custom-table/${id}/drop`, { headers });
};



export const addCustomTable = (data, filterData, isValidFilter) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await addCustomTableAPI(data);
            dispatch(fetchEnd());
            if (response.data && response.data.status === 400) {
                const failed = response.data.response?.failed || [];
                if (failed.length > 0) {
                    failed.forEach((item) => {
                        const errorMessage = `${item.field_name || ''}: ${item.error}`;
                        globalToast.showError(errorMessage);
                    });
                    if (response.data.message) globalToast.showError(response.data.message);
                    return { success: false, error: response.data.response };
                }
                globalToast.showError(response.data.message || 'Failed to save table.');
                return { success: false, error: response.data };
            }
            const logNumber = response?.data?.log_number;
            if (response?.data?.response?.table_name && filterData && isValidFilter) {
                dispatch(addFilterConfiguration(filterData, true));
            } else if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
                history.push('/custom-table-configuration-page');
            } else {
                globalToast.showSuccess(
                    `Table '${response?.data?.response?.table_name}' has been Created successfully!`,
                );
                history.push('/custom-table-configuration-page');
            }
            dispatch(addCustomTableSuccess(response.data.response));
            return { success: true, response };
        } catch (error) {
            dispatch(fetchEnd());
            return { success: false, error };
        }
    };
};

const addCustomTableAPI = (data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post('mdm/custom-table', data, { headers });
};

const addCustomTableSuccess = (data) => ({
    type: ADD_CUSTOM_TABLE_SUCCESS,
    data,
});

export const activateCustomTable = (id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        activateCustomTableAPI(id)
            .then(async (response) => {
                dispatch(fetchEnd());
                dispatch(activateCustomTableSuccess(response.data.response));
                const logNumber = response?.data?.log_number;
                if (response?.data?.response) {
                    globalToast.showSuccess(response.data.response);
                } else if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                }
                dispatch(getCustomTables());
            })
            .catch(async (error) => {
                dispatch(fetchEnd());
                if (!error?.response?.data?.log_number) {
                    globalToast.showError(
                        error?.response?.data?.message || 'Failed to activate custom table',
                    );
                }
                dispatch(activateCustomTableFail(error));
            });
    };
};

const activateCustomTableAPI = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(`/mdm/custom-table/${id}/activate`, null, { headers });
};

export const activateCustomTableSuccess = (data) => ({
    type: ACTIVATE_CUSTOM_TABLE,
    payload: data,
});

export const activateCustomTableFail = (error) => ({
    type: `${ACTIVATE_CUSTOM_TABLE}_FAIL`,
    error,
});

export const getCustomTables = () => {
    return (dispatch) => {
        getCustomTablesAPI()
            .then((response) => {
                dispatch(getCustomTablesSuccess(response.data.response));
            })
            .catch((error) => { });
    };
};

const getCustomTablesAPI = () => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.get('mdm/custom-tables', { headers });
};

export const getCustomTablesSuccess = (data) => ({
    type: GET_CUSTOM_TABLES,
    data,
});

export const getCustomTableById = (id) => {
    return (dispatch) => {
        return getCustomTableByIdAPI(id)
            .then((response) => {
                dispatch(getCustomTableByIdSuccess(response.data.response));
                return response.data.response;
            })
            .catch((error) => {
                throw error;
            });
    };
};

const getCustomTableByIdAPI = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.get(`mdm/custom-table/${id}`, { headers });
};

const getCustomTableByIdSuccess = (data) => ({
    type: GET_CUSTOM_TABLE_BY_ID_SUCCESS,
    data,
});

export const updateCustomTable = (id, data, filterID, filterData, isValidFilter, shouldDeleteFilter) => async (dispatch) => {
    dispatch(fetchStart());
    try {
        const response = await axios.put(`mdm/custom-table/${id}`, data, {
            headers: {
                Authorization: secureLocalStorage.getItem('aTk'),
                'Content-Type': 'application/json',
            },
        });
        dispatch(fetchEnd());

        dispatch({
            type: EDIT_CUSTOM_TABLE_SUCCESS,
            data: response.data,
        });

        const tableName = response.data.response?.table_name || 'Custom Table';
        const logNumber = response?.data?.log_number;
        if (response?.data?.response?.table_name && isValidFilter) {
            if (filterID)
                dispatch(updateFilterConfiguration(filterID, filterData, true));
            else
                dispatch(addFilterConfiguration(filterData, true, 'edit'));
        } else if (response?.data?.response?.table_name && shouldDeleteFilter && filterID) {
            dispatch(deleteFilterConfiguration(filterID, tableName));
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(`Table '${tableName}' has been Updated successfully!`);
            }
            history.push('/custom-table-configuration-page');
        } else if (logNumber) {
            await handleExecutionLog(dispatch, logNumber);
            history.push('/custom-table-configuration-page');
        } else {
            globalToast.showSuccess(`Table '${tableName}' has been Updated successfully!`);
            history.push('/custom-table-configuration-page');
        }

        return response.data.response;
    } catch (error) {
        dispatch(fetchEnd());
        dispatch({
            type: EDIT_CUSTOM_TABLE_FAIL,
            error: error?.response?.data || 'Unknown error',
        });
        return null;
    }
};

//Extend Table Actions
export const getExtendTableFields = (tableName) => {
    return (dispatch) => {
        return getExtendTableFieldsAPI(tableName)
            .then((response) => {
                dispatch(getExtendTableFieldsSuccess(response.data.response));
                return response.data.response;
            })
            .catch((error) => {
                dispatch(getExtendTableFieldsSuccess(null));
                globalToast.showError(
                    error?.response?.data?.message || 'Failed to fetch table fields',
                );
                return null;
            });
    };
};

const getExtendTableFieldsAPI = (tableName) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.get(`mdm/extend-table/${tableName}/fields`, { headers });
};

export const getExtendTableFieldsSuccess = (data) => ({
    type: GET_EXTEND_TABLE_FIELDS_SUCCESS,
    data,
});


export const saveExtendTableFields = (tableName, { newFields = [], updatedFields = [], deletedFieldIds = [] }) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const responses = [];
            const changedFields = [
                ...updatedFields,
                ...deletedFieldIds.map((id) => ({ id, deleted: true })),
            ];
            if (changedFields.length > 0) {
                responses.push(await updateExtendTableFieldsAPI(tableName, { fields: changedFields }));
            }
            if (newFields.length > 0) {
                responses.push(await addExtendTableFieldsAPI(tableName, { fields: newFields }));
            }
            const failedResponse = responses.find((response) => response.data && response.data.status === 400);
            if (failedResponse) {
                dispatch(fetchEnd());
                const failed = failedResponse.data.response?.failed || [];
                failed.forEach((item) => {
                    globalToast.showError(`${item.field_name || ''}: ${item.error}`);
                });
                globalToast.showError(failedResponse.data.message || 'Failed to save fields.');
                return { success: false, error: failedResponse.data };
            }
            const logNumber = responses.map((response) => response?.data?.log_number).find(Boolean);
            dispatch(fetchEnd());
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(`Fields for table '${tableName}' have been saved successfully!`);
            }
            history.push('/extend-table-configuration-page');
            return { success: true };
        } catch (error) {
            dispatch(fetchEnd());
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showError(error?.response?.data?.message || 'Failed to save fields');
            }
            return { success: false, error };
        }
    };
};

const addExtendTableFieldsAPI = (tableName, data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(`mdm/extend-table/${tableName}/fields`, data, { headers });
};

const updateExtendTableFieldsAPI = (tableName, data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
    };
    return axios.put(`mdm/extend-table/${tableName}/fields`, data, { headers });
};

export const activateExtendTable = (tableName) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await activateExtendTableAPI(tableName);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (response?.data?.response && typeof response.data.response === 'string') {
                globalToast.showSuccess(response.data.response);
            } else if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(`Table '${tableName}' has been activated successfully!`);
            }
            return { success: true };
        } catch (error) {
            dispatch(fetchEnd());
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showError(
                    error?.response?.data?.message || 'Failed to activate table',
                );
            }
            return { success: false, error };
        }
    };
};

const activateExtendTableAPI = (tableName) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(`mdm/extend-table/${tableName}/activate`, null, { headers });
};

// ─── Custom Data Actions ──────────────────────────────────────────────────────

const getSearchPayload = () => {
    try {
        const lastSearchPayload = sessionStorage.getItem('lastSearchPayload');
        if (lastSearchPayload) return JSON.parse(lastSearchPayload);
        const ALLDATAPAYLOAD = sessionStorage.getItem('ALLDATAPAYLOAD');
        if (ALLDATAPAYLOAD) return JSON.parse(ALLDATAPAYLOAD);
        return null;
    } catch {
        return null;
    }
};

export const searchCustomTableData = (selectedProfile, data, type) => {
    return (dispatch) => {
        dispatch(fetchStart());
        const tableName =
            typeof selectedProfile === 'string'
                ? selectedProfile
                : selectedProfile?.db_table_name;
        searchCustomTableApi(tableName, data)
            .then((response) => {
                dispatch(fetchEnd());
                const result = response.data.response;
                dispatch(searchCustomTableDataSuccess(result));
                if ((!result?.records || result.records.length === 0 || result.records === null) && type !== 'noFilter') {
                    globalToast.showInfo('No data to show');
                    if (typeof selectedProfile !== 'string') {
                        return;
                    }
                }
                if (typeof selectedProfile !== 'string') {
                    history.push({
                        pathname: '/custom-data-maintenance-grid',
                        state: { selectedProfile: selectedProfile },
                    });
                }
            })
            .catch((error) => {
                dispatch(fetchEnd());
                const rawError = error.response?.data;
                const errorResponse = rawError?.response ? rawError.response : rawError;
                throw errorResponse || error;
            });
    };
};

const searchCustomTableApi = (tableName, data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(`/mdm/table/search/${tableName}`, data, { headers });
};

export const searchCustomTableDataSuccess = (data) => ({
    type: CUSTOM_TABLE_SEARCH_SUCCESS,
    data,
});

export const uploadCustomDataFile = (tableName, file, selectedProfile, overwrite) => {
    return (dispatch) => {
        dispatch(fetchStart());
        return uploadCustomDataFileApi(tableName, file, overwrite)
            .then(async (response) => {
                dispatch(fetchEnd());
                if (response.data.message) {
                    dispatch(CustomDataUploadFailure([]));
                    return response;
                }
                dispatch(fetchCustomDataUploadSuccess(response.data.response));
                const logNumber = response?.data?.log_number;
                if (!response?.data?.response && logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                }
                dispatch(searchCustomTableData(tableName, getSearchPayload()));
                history.push('/custom-data-maintenance-grid', {
                    selectedProfile: selectedProfile,
                    mode: 'Update',
                });
                return response;
            })
            .catch(async (error) => {
                dispatch(fetchEnd());
                dispatch(CustomDataUploadFailure([]));
                const rawError = error.response?.data;
                const errorResponse = rawError?.response ? rawError.response : rawError;
                history.push('/custom-data-maintenance-grid', {
                    selectedProfile,
                    mode: 'Update',
                });
                throw errorResponse || error;
            });
    };
};

const uploadCustomDataFileApi = (tableName, file, overwrite) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'multipart/form-data;',
    };
    return axios.post(`/mdm/table/${tableName}/upload?overwrite=${overwrite}`, file, { headers });
};

export const fetchCustomDataUploadSuccess = (data) => ({
    type: CUSTOM_DATA_FORMAT_SUCCESS,
    data,
});

export const CustomDataUploadFailure = (data) => ({
    type: CUSTOM_DATA_UPLOAD_FAILURE,
    data,
});

export const deleteCustomFieldData = (tableName, rowId) => {
    return async (dispatch) => {
        try {
            const response = await deleteCustomFieldDataAPI(tableName, rowId);
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(response.data.response);
            }
            dispatch(searchCustomTableData(tableName, getSearchPayload()));
        } catch (error) {
            if (!error?.response?.data?.log_number) {
                globalToast.showError(error?.response?.data?.message || 'Failed to delete row');
            }
        }
    };
};

const deleteCustomFieldDataAPI = (tableName, rowId) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.delete(`mdm/table/${tableName}/data/${rowId}`, { headers });
};

export const addCustomTableFilteredDataApi = (tableName, formData, selectedProfile) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await addCustomTablePostApi(tableName, formData);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (response?.data?.response) {
                dispatch(addCustomTableDataSuccess(response.data.response.records));
            } else if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
            dispatch(searchCustomTableData(tableName, getSearchPayload()));
            history.push('/custom-data-maintenance-grid', {
                selectedProfile: selectedProfile,
                mode: 'Update',
            });
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            throw error;
        }
    };
};

const addCustomTablePostApi = (tableName, formData) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(`/mdm/table/${tableName}/data`, formData, { headers });
};

export const addCustomTableDataSuccess = (data) => ({
    type: CUSTOM_TABLE_FILTER_DATA_SUCCESS,
    data,
});

export const updateCustomTableData = (tableName, data, selectedProfile) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await updateCustomTableApi(tableName, data);
            dispatch(fetchEnd());
            if (response?.data?.response) {
                dispatch(updateCustomTableDataSuccess(response.data.response));
            }
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
            dispatch(searchCustomTableData(tableName, getSearchPayload()));
            if (selectedProfile) {
                history.push('/custom-data-maintenance-grid', {
                    selectedProfile: selectedProfile,
                    mode: 'Update',
                });
            }
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            throw error;
        }
    };
};

const updateCustomTableApi = (tableName, data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
    };
    return axios.put(`/mdm/table/${tableName}/data`, data, { headers });
};

export const updateCustomTableDataSuccess = (data) => ({
    type: CUSTOM_TABLE_UPDATE_SUCCESS,
    data,
});

// ── Layout Render ──────────────────────────────────────────────────────────

/**
 * `silent` means "render this for the caller only, touch no global state": it skips
 * both the fetchStart/fetchEnd spinner and the layoutRenderData write.
 *
 * Inline previews need it on both counts. The shared loader paints a fullscreen
 * overlay that would cover the screen the preview lives on, and layoutRenderData is
 * a single shared slot — a preview re-rendering on every selection would keep
 * overwriting it on behalf of whichever feature actually owns it.
 *
 * The result still comes back through the returned { success, data }, which is how
 * every current caller reads it.
 */
export const getLayout = (data, exportType, params, silent) => {
    return (dispatch) => {
        if (!silent) dispatch(fetchStart());
        return getLayoutAPI(data, exportType, params)
            .then((response) => {
                if (!silent) dispatch(fetchEnd());
                if (!silent) dispatch(getLayoutSuccess(response.data));
                return { success: true, data: response.data };
            })
            .catch((error) => {
                if (!silent) dispatch(fetchEnd());
                return { success: false, error };
            });
    };
};

const getLayoutAPI = (data, exportType, params) => {
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    if (exportType === 'pdf') {
        // Same endpoint as the HTML call: it is the *absence* of `HTML=true` in the
        // params that selects PDF, and the response is raw PDF bytes rather than the
        // { status, log_number, html_content } envelope. `params` still carries
        // application_type and functionality, which choose the layout — the previous
        // form of this branch posted to `?pdf=true` and dropped them entirely, so it
        // could not have selected the right layout. Nothing called it.
        return axios.post('layout/render', data, { headers, params, responseType: 'blob' });
    }
    return axios.post('layout/render', data, { headers, params });
};

export const getLayoutSuccess = (data) => ({
    type: LAYOUT_RENDER_SUCCESS,
    data,
});

// ── Filter Configuration Actions ──────────────────────────────────────────────

export const deleteFilterConfiguration = (id, filterGroup) => {
    return (dispatch) => {
        return deleteFilterConfigurationAPI(id)
            .then(async (response) => {
                dispatch({
                    type: DELETE_FILTER_CONFIGURATION_SUCCESS,
                    payload: response.data,
                });
                const logNumber = response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                } else {
                    toast.success(`Filter Group '${filterGroup}' has been deleted successfully`);
                }
            })
            .catch(async (error) => {
                dispatch({ type: DELETE_FILTER_CONFIGURATION_FAIL });
            });
    };
};

export const deleteFilterConfigurationAPI = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'application/json',
    };
    return axios.delete(`/filter-configuration/${id}`, { headers });
};

export const addFilterConfiguration = (data, isCalledFromOutside, mode, application, page) => {
    return (dispatch) => {
        dispatch(fetchStart());
        return addFilterConfigurationAPI(data)
            .then(async (response) => {
                dispatch(fetchEnd());
                if (response.data && response.data.status === 400) {
                    const failed = response.data.response?.failed || [];
                    if (failed.length > 0) {
                        failed.forEach((item) => {
                            toast.error(`${item.field_name || ''}: ${item.error}`);
                        });
                        if (response.data.message) toast.error(response.data.message);
                        return { success: false, error: response.data.response };
                    }
                    toast.error(response.data.message || 'Failed to save filter Group.');
                    return { success: false, error: response.data };
                }

                const navigateAfterSave = () => {
                    if (isCalledFromOutside) {
                        if (page === 'Predefined Queries')
                            history.push('/query-field', { application: 'Data Insights' });
                        else
                            history.push('/custom-table-configuration-page');
                    } else {
                        history.push({ pathname: '/global-filter-configuration-page', state: { application } });
                    }
                };

                const logNumber = response?.data?.log_number;
                const filterGroup = response?.data?.response?.filter_group;
                if (filterGroup) {
                    const message = isCalledFromOutside
                        ? `${page === 'Predefined Queries' ? 'Query' : 'Table'} '${filterGroup}' has been ${mode === 'edit' ? 'updated' : 'created'} successfully!`
                        : `Filter Group '${filterGroup}' has been created successfully!`;
                    globalToast.showSuccess(message);
                } else if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                } else {
                    globalToast.showSuccess('Filter Group has been saved successfully!');
                }
                navigateAfterSave();
                dispatch(addFilterConfigurationSuccess(response.data.response));
                return { success: true, response };
            })
            .catch(async (error) => {
                dispatch(fetchEnd());
                return { success: false, error };
            });
    };
};

const addFilterConfigurationAPI = (data) => {
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    return axios.post('/filter-configuration', data, { headers });
};

const addFilterConfigurationSuccess = (data) => ({
    type: ADD_FILTER_CONFIGURATION_SUCCESS,
    data,
});

export const getFilterConfigurations = (param, type, page) => {
    return (dispatch) => {
        dispatch(fetchStart());
        return getFilterConfigurationsAPI(param)
            .then((response) => {
                if (type === 'Custom Data')
                    dispatch(getFilterConfigurationsByPageSuccess(response.data.response));
                else if (type === 'BatchJob')
                    dispatch(getFilterConfigurationsSuccess({ [page]: response.data.response || [] }));
                else
                    dispatch(getFilterConfigurationsSuccess(response.data.response));
                dispatch(fetchEnd());
                return response.data.response;
            })
            .catch(() => {
                dispatch(fetchEnd());
            });
    };
};

export const getFilterConfigurationsAPI = (param) => {
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    return axios.get('/filter-configuration', { params: param, headers });
};

const getFilterConfigurationsSuccess = (data) => ({
    type: GET_FILTER_CONFIGURATIONS,
    data,
});

const getFilterConfigurationsByPageSuccess = (data) => ({
    type: GET_FILTER_CONFIGURATIONS_BY_PAGE,
    data,
});

export const getFilterConfigurationById = (id) => {
    return (dispatch) => {
        return getFilterConfigurationByIdAPI(id)
            .then((response) => {
                dispatch(getFilterConfigurationByIdSuccess(response.data.response));
                return response.data.response;
            })
            .catch((error) => {
                throw error;
            });
    };
};

const getFilterConfigurationByIdAPI = (id) => {
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    return axios.get(`/filter-configuration/${id}`, { headers });
};

const getFilterConfigurationByIdSuccess = (data) => ({
    type: GET_FILTER_CONFIGURATION_BY_ID_SUCCESS,
    data,
});

// ── Global Dynamic API Runner ──────────────────────────────────────────────

export const runGlobalAPI = (data, apiPath) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await runGlobalAPICall(data, apiPath);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            throw error;
        }
    };
};

export const runGlobalAPILogDataSuccess = (data) => {
    return {
        type: RUN_GLOBAL_API_LOG_DATA,
        data,
    };
};

// Same call as runGlobalAPI, but log display is driven through the reducer:
// - response has data  -> store it in `globalApiLogData` (page shows the popup)
// - response is empty  -> fall back to handleExecutionLog via the log_number
export const runGlobalAPIRequest = (data, apiPath) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await runGlobalAPICall(data, apiPath);
            dispatch(fetchEnd());
            const responseData = response?.data?.response;
            const hasResponse = Array.isArray(responseData)
                ? responseData.length > 0
                : !!responseData;

            if (hasResponse) {
                dispatch(runGlobalAPILogDataSuccess(responseData));
            } else {
                const logNumber = response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                }
            }
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            throw error;
        }
    };
};

const runGlobalAPICall = (data, apiPath) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.post(apiPath, data, { headers });
};

export const inactivateFilterConfiguration = (id, inActiveValue, appTypeParam) => {
    return (dispatch) => {
        return axios
            .put(`/filter-configuration/${id}`, { in_active: inActiveValue }, {
                headers: { Authorization: secureLocalStorage.getItem('aTk') },
            })
            .then(async (response) => {
                const logNumber = response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                } else {
                    globalToast.showSuccess(
                        inActiveValue
                            ? 'Filter group has been inactivated!'
                            : 'Filter group has been activated!'
                    );
                }
                return dispatch(getFilterConfigurations(appTypeParam));
            })
            .catch(async (error) => {
                if (!error?.response?.data?.log_number) {
                    globalToast.showError(
                        error?.response?.data?.message || 'Failed to update filter group status.'
                    );
                }
                throw error;
            });
    };
};

const setDefaultFilterConfigurationAPI = (id, isDefaultValue) => {
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    return axios.post(`/filter-configuration/${id}/default`, { is_default: isDefaultValue }, { headers });
};

export const setDefaultFilterConfiguration = (id, isDefaultValue, appTypeParam) => {
    return (dispatch) => {
        return setDefaultFilterConfigurationAPI(id, isDefaultValue)
            .then(async (response) => {
                const logNumber = response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                } else {
                    globalToast.showSuccess(
                        isDefaultValue
                            ? 'Filter group has been set as default!'
                            : 'Filter group has been removed as default!'
                    );
                }
                return dispatch(getFilterConfigurations(appTypeParam));
            })
            .catch(async (error) => {
                if (!error?.response?.data?.log_number) {
                    globalToast.showError(
                        error?.response?.data?.message || 'Failed to update default filter group.'
                    );
                }
                throw error;
            });
    };
};

// External Data Mapping
const externalDataMappingHeaders = () => ({
    Authorization: secureLocalStorage.getItem('aTk'),
});

// Request errors (toast + execution log) are handled globally by the axios
// interceptor, so these actions don't catch them; they only stop the loader.
export const getExternalDataMappingById = (id) => {
    return async (dispatch) => {
        dispatch(getExternalDataMappingByIdSuccess(null));
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/config/external-data-mapping/${id}`, {
                headers: externalDataMappingHeaders(),
            });
            dispatch(getExternalDataMappingByIdSuccess(response.data.response));
        } finally {
            dispatch(fetchEnd());
        }
    };
};

export const getExternalDataMappingByIdSuccess = (data) => {
    return {
        type: GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS,
        data,
    };
};

export const createExternalDataMapping = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post('/config/external-data-mapping', data, {
                headers: externalDataMappingHeaders(),
            });
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                const { hasError } = await handleExecutionLog(dispatch, logNumber);
                return { success: !hasError };
            }
            if (response?.data?.message) {
                globalToast.showSuccess(response.data.message);
            }
            return { success: true };
        } finally {
            dispatch(fetchEnd());
        }
    };
};

export const updateExternalDataMapping = (id, data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.put(`/config/external-data-mapping/${id}`, data, {
                headers: externalDataMappingHeaders(),
            });
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                const { hasError } = await handleExecutionLog(dispatch, logNumber);
                return { success: !hasError };
            }
            if (response?.data?.message) {
                globalToast.showSuccess(response.data.message);
            }
            return { success: true };
        } finally {
            dispatch(fetchEnd());
        }
    };
};

export const deleteExternalDataMapping = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.delete(`/config/external-data-mapping/${data.id}`, {
                headers: externalDataMappingHeaders(),
            });
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                const { hasError } = await handleExecutionLog(dispatch, logNumber);
                return { success: !hasError };
            }
            if (response?.data?.message) {
                globalToast.showSuccess(response.data.message);
            }
            return { success: true };
        } finally {
            dispatch(fetchEnd());
        }
    };
};
